import * as React from "react";
import {Route, Switch} from "react-router-dom";
import {history} from "load/store";
import BuyGold from "egold/pages/buyGold";
import Locker from "egold/pages/locker";
import SellGold from "egold/pages/sellGold";
import Orders from "egold/pages/order";
import Delivery from "egold/pages/delivery";
import ProductDetails from "egold/pages/delivery/productDetails";
import ConfirmBuyPayment from "egold/pages/buyGold/paymentConfirm";
import ConfirmSellPayment from "egold/pages/sellGold/confirmSell";
import OrderSuccess from "egold/components/orderSuccess";
import BankDetails from "egold/pages/sellGold/bankDetails";
import OrderDetails from "egold/pages/order/orderDetails";
import DeliveryAddress from "egold/pages/delivery/deliveryAddress";
import ConfirmDelivery from "egold/pages/delivery/confirmDelivery";
import TermsAndConditions from "egold/pages/termsAndConditions";
import {OrderFail} from "egold/components/orderFail";
import VerifiedBankAccount from "egold/pages/sellGold/verifiedBankAccount";
export let indexPath = null;

export enum routePaths {
    BUY_GOLD = "",
    DELIVERY = "/getDelivery",
    LOCKER = "/locker",
    ORDERS = "/orders",
    SELL_GOLD = "/sellGold",
    CONFIRM_BUY_PAYMENT = "/confirmBuy",
    CONFIRM_SELL_PAYMENT = "/confirmSell",
    ORDER_SUCCESS = "/orderSuccess",
    BANK_DETAILS = "/bankDetails",
    ORDER_DETAILS = "/orderDetails",
    PRODUCT_DETAILS = "/productDetails",
    DELIVERY_DETAILS = "/delivery-address",
    CONFIRM_DELIVERY = "/confirm-delivery",
    TERMS_AND_CONDITIONS = "/terms-conditions",
    ORDER_FAIL = "/order-fail",
    VERIFIED_BANK_ACCOUNT = "/verified-bank-account",
}

export function getRoutes(path: string) {
    return (
        <Switch>
            <Route exact path={`${path}${routePaths.BUY_GOLD}`} component={BuyGold}/>
            <Route exact path={`${path}${routePaths.CONFIRM_BUY_PAYMENT}`} component={ConfirmBuyPayment}/>

            <Route exact path={`${path}${routePaths.DELIVERY}`} component={Delivery}/>
            <Route exact path={`${path}${routePaths.PRODUCT_DETAILS}`} component={ProductDetails}/>
            <Route exact path={`${path}${routePaths.DELIVERY_DETAILS}`} component={DeliveryAddress}/>
            <Route exact path={`${path}${routePaths.CONFIRM_DELIVERY}`} component={ConfirmDelivery}/>

            <Route exact path={`${path}${routePaths.LOCKER}`} component={Locker}/>
            <Route exact path={`${path}${routePaths.ORDERS}`} component={Orders}/>
            <Route exact path={`${path}${routePaths.ORDER_DETAILS}`} component={OrderDetails}/>

            <Route exact path={`${path}${routePaths.SELL_GOLD}`} component={SellGold}/>
            <Route exact path={`${path}${routePaths.CONFIRM_SELL_PAYMENT}`} component={ConfirmSellPayment}/>
            <Route exact path={`${path}${routePaths.BANK_DETAILS}`} component={BankDetails}/>
            <Route exact path={`${path}${routePaths.ORDER_SUCCESS}`} component={OrderSuccess}/>
            <Route exact path={`${path}${routePaths.TERMS_AND_CONDITIONS}`} component={TermsAndConditions}/>
            <Route exact path={`${path}${routePaths.ORDER_FAIL}`} component={OrderFail}/>
            <Route exact path={`${path}${routePaths.VERIFIED_BANK_ACCOUNT}`} component={VerifiedBankAccount}/>
        </Switch>
    );
}
export function setIndexPath(path: string) {
    indexPath = path;
}
export function handleNavigation(navigateToPath: string) {
    if (indexPath) {
        history.push({pathname: `${indexPath}${navigateToPath}`});
    }
}
